import { render, staticRenderFns } from "./AttributesContext.vue?vue&type=template&id=22bd3744&scoped=true"
import script from "./AttributesContext.vue?vue&type=script&lang=js"
export * from "./AttributesContext.vue?vue&type=script&lang=js"
import style0 from "./AttributesContext.vue?vue&type=style&index=0&id=22bd3744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd3744",
  null
  
)

export default component.exports